
import { Component } from 'react';
import Login from './components/Login';
import ProjectList from './components/Project/ProjectList';
import Header from './components/Affichage/Header';
import Step1ProjectPDF from './components/Project/Step1ProjectPDF';
import Step2ProjectPDF from './components/Project/Step2ProjectPDF';
import OneStepProjectPDF from './components/Project/OneStepProjectPDF';
import CapCallProjectPDF from './components/Project/CapCallProjectPDF';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { isFirefox } from 'react-device-detect';
import Step1NotificationLetterService from './components/services/Step1NotificationLetterService';
import Step2NotificationLetterService from './components/services/Step2NotificationLetterService';
import GeographicalReportService from './components/services/GeographicalReportService';
import SubsidyContractService from './components/services/SubsidyContractService';
import SubsidyContractCoverService from './components/services/SubsidyContractCoverService';
import ClosureLetterService from './components/services/ClosureLetterService';
import CapCallNotificationLetterService from './components/services/CapCallNotificationLetterService';

// Import CSS
import './css/print.css';
import './css/maplibre-gl.css';
import './App.css';
import './css/debug.css';
import './css/assessmentReport.css';
import './css/letters.css';
import './css/contract.css';
import './css/carto.css';
import StateAidLetterService from './components/services/StateAidLetterService';


class App extends Component {
  pageChange = () => {
    if (this.props.connected) {
      switch (this.props.page) {
        case 'Projects':
          return (
            <ProjectList />
          )
        case 'DetailStep1':
          return (
            <Step1ProjectPDF project={this.props.project} />
          )
        case 'DetailStep2':
          return (
            <Step2ProjectPDF project={this.props.project} />
          )
        case 'CapCallAssessment':
          return (
            <CapCallProjectPDF project={this.props.project} />
          )
        case 'NotificationLetterStep1':
          return (
            <Step1NotificationLetterService project={this.props.project} />
          )
        case 'NotificationLetterStep2':
          return (
            <Step2NotificationLetterService project={this.props.project} />
          )
        case 'NotificationLetterCapCallApproval':
          return (
            <CapCallNotificationLetterService decision='APPROVAL' />
          )
        case 'NotificationLetterCapCallRejection':
          return (
            <CapCallNotificationLetterService decision='REJECTION' />
          )
        case 'Cartographie':
          return (
            <GeographicalReportService project={this.props.project} />
          )
        case 'SubsidyContract':
          return (
            <SubsidyContractService project={this.props.project} />
          )
        case 'SubsidyContractCover':
          return (
            <SubsidyContractCoverService project={this.props.project} />
          )
        case 'DetailOneStep':
          return (
            <OneStepProjectPDF project={this.props.project} />
          )
        case 'StateAid':
          return (
            <StateAidLetterService project={this.props.project} />
          )
        case 'Closure':
            return (
              <ClosureLetterService project={this.props.project} />
            )
        default:
          return <Login />
      }
    } else {
      return <Login />
    }
  }

  render() {
    return (
      <div className="app">
        {isFirefox ? <Message warning><Message.Header>It seems you're using Mozilla Firefox Web Browser, this App is designed to be used by Microsoft Edge or Google Chrome browser.</Message.Header>Please consider that using Firefox may result on bad formatted reports creation</Message> : undefined}
        {<Header />}
        {this.pageChange()}
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    page: state.app.page,
    connected: state.app.connected,
    project: state.project.project,
    projectChecklists: state.project.projectChecklists
  }
}

export default connect(mapStateToProps)(App);